module.exports = __webpack_public_path__ + "img/GA4.524014e2.svg";